( function( $ ) {
    "use strict";

    window.Parsley.setLocale('fr');

    $('body').on('app.init', function(ev) {
        var $container = $(ev.container);

        $container.find("[gr-form]").length && $container.find("[gr-form]").parsley({
            trigger:      'change',
            errorClass: "parsley-error",
            classHandler: function (el) {
                return el.$element.closest('.gr-form__field, .gr-form__field--inline, .gr-form__field--icon-after, .gr-form__field--icon-before');
            },
            errorsContainer: function(pEle) {
                var $err = pEle.$element.closest('.gr-form__field, .gr-form__field--inline, .gr-form__field--icon-after, .gr-form__field--icon-before').append();
                return $err;
            }
        });
    });

} )( require('jquery'), require('../../../node_modules/parsleyjs/dist/parsley.min.js'), require('../../../node_modules/parsleyjs/dist/i18n/fr.js') );